import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PackSettings } from '../models';
import { getLatestPackTemplates, isPackTemplatesLoading } from '../store/settings/selectors';
import { loadPackTemplates } from '../store/settings/actions';

export interface PackTemplatesHook {
    templates: PackSettings[];
    loading: boolean;
}

export const usePackTemplates = (): PackTemplatesHook => {
    const dispatch = useDispatch();
    const templates = useSelector(getLatestPackTemplates) ?? [];
    const loading = useSelector(isPackTemplatesLoading);

    useEffect(() => {
        dispatch(loadPackTemplates());
    }, [dispatch]);

    return { templates, loading };
};
